import { distanceMeters } from "@/utils/geo"

export type NormalizedGeoPoint = {
  id: string
  title: string
  lat: number
  lng: number
  radiusM: number
  isAvailable?: boolean
  meta?: string
}

export function normalizeGeoPoint(raw: {
  id: string
  title?: string
  name?: string
  lat?: number
  lng?: number
  latitude?: number
  longitude?: number
  radiusM?: number
  radiusMeters?: number
  isAvailable?: boolean
  meta?: string
}): NormalizedGeoPoint {
  return {
    id: raw.id,
    title: raw.title ?? raw.name ?? raw.id,
    lat: raw.lat ?? raw.latitude ?? 0,
    lng: raw.lng ?? raw.longitude ?? 0,
    radiusM: raw.radiusM ?? raw.radiusMeters ?? 80,
    isAvailable: raw.isAvailable,
    meta: raw.meta,
  }
}

export function isInGeoRadius(
  gps: { lat: number; lng: number },
  point: NormalizedGeoPoint
): boolean {
  return (
    distanceMeters(gps.lat, gps.lng, point.lat, point.lng) <= point.radiusM
  )
}
